import React from 'react'

//
import { Kpi, List, ButtonNew } from '../../../storybook/'
import { getUrl } from '../../../utils/urls'
import { LocationContext } from '../../page-wrapper'
import { BUTTON_VARIANT } from '../../../storybook/ButtonNew/ButtonNew'
import { useNavigationData } from '@/src/context/NavigationContext'

const BlockTwoBlocksBanner = ({ data: { simpleContentBlocks } }) => {
  const { navigationItems } = useNavigationData()
  const location = React.useContext(LocationContext)
  const { slugPrefix } = location

  return (
    <section className="l-section">
      <div className="l-container:12/12 l-container--default-spacing">
        <div className="l-section__content">
          <div className="l-grid l-grid--default-spacing">
            {simpleContentBlocks?.map(
              ({ id, icon, title, description, bulletPoints, action }, idx1) => (
                <div
                  key={`${id}-${idx1}`}
                  className="l-grid_col:12/12 l-grid__col:6/12@at:viewport-7"
                >
                  <Kpi icon={icon || ''} title={title || ''} description={description || ''}>
                    {bulletPoints && (
                      <List
                        type="ul"
                        icon="interface/checkmark"
                        items={bulletPoints.map((bulletPoint, idx2) => ({
                          id: `${bulletPoint.id}-${idx2}`,
                          textTokens: {},
                          text: bulletPoint.content
                        }))}
                      />
                    )}

                    {action && (
                      <ButtonNew
                        url={getUrl({
                          navItem: action,
                          slugPrefix: slugPrefix,
                          navigationItems: navigationItems
                        })}
                        icon="ti-arrow-narrow-right"
                        variant={BUTTON_VARIANT.SECONDARY}
                        classes={bulletPoints && 'u-margin-top:24'}
                      >
                        {action.title}
                      </ButtonNew>
                    )}
                  </Kpi>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default BlockTwoBlocksBanner
